import React from "react";
import { Link } from "react-router-dom";
import { formatLeagueCellValue } from "./leagueUtils";

const getColumnLabel = (column) => {
	const labels = {
		name: "Nombre",
		type: "Tipo",
		countryId: "CountryId",
		logoUrl: "Logo",
		externalId: "ExternalId",
		season: "Season",
		startDate: "Fecha inicio",
		endDate: "Fecha fin",
		importFixtures: "ImportFixtures",
		fixturesImportedOn: "FixturesImportedOn",
		importFixtureResults: "ImportFixtureResults",
		fixtureResultsImportedOn: "FixtureResultsImportedOn",
		importFixtureEvents: "ImportFixtureEvents",
		fixtureEventsImportedOn: "FixtureEventsImportedOn",
		championTeamId: "ChampionTeamId",
		subChampionTeamId: "SubChampionTeamId",
	};

	return labels[column] || column;
};

function LeagueListItem({ columns, league }) {
	return (
		<tr>
			{columns.map((column) => (
				<td key={`${league.uniqueIdentifier}-${column}`}>
					{column === "logoUrl" ? (
						league.logoUrl ? (
							<img
								alt={`Logo ${league.name}`}
								src={league.logoUrl}
								style={{ width: "40px", height: "40px", objectFit: "contain" }}
							/>
						) : (
							"-"
						)
					) : (
						formatLeagueCellValue(column, league[column])
					)}
				</td>
			))}
			<td>
				<Link to={`/leagues/${league.uniqueIdentifier}`}>Editar</Link>
			</td>
		</tr>
	);
}

export { getColumnLabel };
export default LeagueListItem;